import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-underdevelopment',
  templateUrl: './underdevelopment.component.html',
  styleUrls: ['./underdevelopment.component.scss'],
})
export class UnderdevelopmentComponent {}
